import { render, staticRenderFns } from "./QuizScreen.vue?vue&type=template&id=7813a76f&"
import script from "./QuizScreen.vue?vue&type=script&lang=js&"
export * from "./QuizScreen.vue?vue&type=script&lang=js&"
import style0 from "./QuizScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports